export default "__VITE_ASSET__310d3dfc__"